import { Tabs, Divider } from 'antd';
import constants from '../../constants/constants';
import { CalendarOutlined, ProfileOutlined } from '@ant-design/icons';
import Budgets from '../Budgets';
import Spend from './Spend';
import { useLocation } from 'react-router-dom';
import BudgetsAdmin from '../admin/BudgetsAdmin';
import { useContext, useEffect } from 'react';
import { useState } from 'react';
import BudgetsMulti from './BugetMulti';
import BudgetSpendMulti from './BudgetSpendMulti';
import BudgetSpendByCostCenterMulti from './BudgetSpendByCostCenterMulti';
import MultiBudgetByCostCenter from '../sub-buyer-admin/MultiBudgetByCostCenter';
import ContractsSpendMulti from './ContractsSpendMulti';
import { trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import { CommonContext } from '../../Context';
const { TabPane } = Tabs;

const BudgetContainerMulti = () => {
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;
    useEffect(() => {
    trackPageAccess(buyerId,window.location.href)
  }, []);
	return (
		<div>
      <div className='uppercase font-bold text-xl'>Multi Budgets</div>
			<Divider className='my-3'/>
			<Tabs defaultActiveKey="1">
			<TabPane
        tab={ <span className='uppercase'><CalendarOutlined className='text-xl' />{constants.BudgetTab1}</span> }
        key={1}
      >
       <BudgetsMulti/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><ProfileOutlined className='text-xl' />{constants.BudgetTab4}</span> }
        key={4}
      >
        <MultiBudgetByCostCenter tabName={constants.MultiBudgetsAdminTab1}/>
      </TabPane>
			<TabPane
        tab={ <span className='uppercase'><ProfileOutlined className='text-xl' />{constants.BudgetTab2}</span> }
        key={2}
      >
        <BudgetSpendMulti/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><ProfileOutlined className='text-xl' />{constants.BudgetTab3}</span> }
        key={3}
      >
        <BudgetSpendByCostCenterMulti/>
      </TabPane>
      <TabPane
        tab={ <span className='uppercase'><ProfileOutlined className='text-xl' />{constants.BudgetTab5}</span> }
        key={5}
      >
        <ContractsSpendMulti/>
      </TabPane>
			</Tabs>
		</div>
	);
};

export default BudgetContainerMulti;